import { createFileRoute } from '@tanstack/react-router'
import SubmissionsPage from '@/pages/SubmissionsPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/submissions/')({
  component: SubmissionsPage,
})